<template>
  <div>
    <div class="page-header bordered">
      <h1>Integrated Sites</h1>
    </div>

    <div v-if="integratedSites.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th> # </th>
            <th> Subdomain </th>
            <th> Domain </th>
            <th> DNS Record Info </th>
            <th> DNS Email Sent </th>
            <th> Actions </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(siteConfiguration, index) in integratedSites" :key="index">
            <td> {{ index }} </td>
            <td> {{ siteConfiguration.subdomain }} </td>
            <td> {{ siteConfiguration.domain }} </td>
            <td class="text-center">
              <i v-if="dnsRecordSaved(siteConfiguration)"
                class="fa fa-check fa-2x text-success" title="DNS Recors saved"></i>
              <i v-else class="fa fa-close fa-2x text-warning"
                title="DNS Recors not saved" aria-hidden="true"></i>
            </td>
            <td class="text-center">
              <i v-if="siteConfiguration.dns_config_email_sent"
                class="fa fa-check fa-2x text-success" title="Email sent"></i>
              <i v-else class="fa fa-close fa-2x text-warning"
                title="Email not sent" aria-hidden="true"></i>
            </td>
            <td>
              <b-button size="sm" variant="info" title="Set DNS configuration"
                v-on:click="editDnsConfiguration(siteConfiguration)">
                <i class="fa fa-cogs"></i>
              </b-button>
              <b-button size="sm" variant="warning" title="Clear DNS configuration"
                v-on:click="clearDnsConfiguration(siteConfiguration, index)">
                <i class="fa fa-eraser"></i>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else>
      <b-alert show>
        <h6> No integrated sites available. </h6>
      </b-alert>
    </div>

    <SiteConfigurationFormModal
      :siteConfiguration="siteConfigurationSelected">
    </SiteConfigurationFormModal>
  </div>
</template>

<script>
import SiteConfigurationFormModal from './IntegratedSites/SiteConfigurationFormModal'

export default {
  name: 'IntegratedSites',
  components: {
    SiteConfigurationFormModal
  },
  data: function () {
    return {
      siteConfigurationSelected: {},
      integratedSites: []
    }
  },
  created () {
    this.getIntegratedSites()
  },
  methods: {
    getIntegratedSites () {
      var self = this
      var loader = this.$loading.show()

      this.$http.get('/site_configurations').then(function (response) {
        self.integratedSites = response.data
      }).finally(function () {
        loader.hide()
      })
    },
    editDnsConfiguration (siteConfiguration) {
      this.siteConfigurationSelected = siteConfiguration
      this.$bvModal.show('siteConfigurationFormModal')
    },
    clearDnsConfiguration (siteConfiguration, index) {
      var self = this

      this.$swal({
        title: 'Confirm DNS configuration deletion?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm!'
      }).then((result) => {
        if (result.value) {
          self.deleteDnsConfigurationLoader = self.$loading.show()

          self.$http.delete('site_configurations/' + siteConfiguration.id + '/remove_dns_configuration')
            .then(function (response) {
              var siteConfiguration = response.data
              // eslint-disable-next-line no-undef
              Vue.set(self.integratedSites, index, siteConfiguration)

              self.$swal({
                title: 'DNS configuration deleted!',
                text: 'For domain ' + siteConfiguration.domain,
                type: 'success'
              })
            }).catch(function (error) {
              if (error) {
                self.$swal({
                  title: 'Error deleting DNS Configuration!',
                  type: 'error'
                })
              }
            }).finally(function () {
              self.deleteDnsConfigurationLoader.hide()
            })
        }
      })
    },
    dnsRecordSaved (siteConfiguration) {
      return (siteConfiguration.dns_cname_record_name && siteConfiguration.dns_cname_record_name.length > 0) &&
        (siteConfiguration.dns_cname_record_value && siteConfiguration.dns_cname_record_value.length > 0)
    }
  }
}
</script>
